module.exports = __webpack_public_path__ + "img/icon-registration.8181e32d.svg";